import { Grid } from '@mui/material';
import React from 'react';
import Section from '../../shared/Section/Section';
import Accordions from '../../shared/Accordions/Accordions';

function FAQWidget({
  questions,
  title = 'F.A.Q.',
  subtitle = '',
  titleH1 = false,
}) {
  return (
    <Section subtitle={subtitle} title={title} titleH1={titleH1} flexGrow>
      <Grid container>
        <Grid item xs={12} md={11}>
          {questions.map(({ q, a }) => (
            <Accordions key={q} summary={q} details={a} />
          ))}
        </Grid>
      </Grid>
    </Section>
  );
}

export default FAQWidget;
